export default "__VITE_ASSET__B9oTtQJ4__"